import React, { useRef } from 'react';

//Utils
import { useToggle } from 'Shared/utils/hooks';
import { useScheduleDemoInOnboardingTracking } from 'Shared/tracking/use-schedule-demo-in-onboarding-tracking';

// Components
import { PopupModal, useCalendlyEventListener } from 'react-calendly';
import WpButton from 'Wpds/components/button/WpButton';
import { WpButtonGroup } from 'Wpds/components/button';
import SocialProof from '../Profile/SocialProof/SocialProof';

import './ScheduleDemo.scss';

type Props = {
  advanceOnboardingState: Function;
};

function ScheduleDemo({ advanceOnboardingState }: Props) {
  const [calendlyModalOpen, toggleCalendlyModalOpen] = useToggle(false);
  const containerRef = useRef();
  const { trackScheduledDemo, trackScheduleDemoButtonClick } = useScheduleDemoInOnboardingTracking();

  useCalendlyEventListener({
    onEventScheduled: e => {
      trackScheduledDemo({ calendlyUrl: e?.data?.payload?.event?.uri });
      // Delay for a half second so they see calendy's confirmation screen
      // before they are sent to the normal onboarding flow
      setTimeout(() => advanceOnboardingState({ scheduled_demo: true }), 500);
    },
  });

  const handleScheduleDemoButtonClick = () => {
    toggleCalendlyModalOpen();
    trackScheduleDemoButtonClick();
  };

  return (
    <div ref={containerRef} className="onboarding-mobile-schedule-demo-page-wrapper-content">
      <div>
        <PopupModal
          url="https://calendly.com/peterhaas/workpatterns-product-tour-website-clone?hide_gdpr_banner=1"
          rootElement={containerRef?.current}
          open={calendlyModalOpen}
          onModalClose={toggleCalendlyModalOpen}
        />
        <div className="onboarding-mobile-schedule-demo-content d-flex flex-column mb-4">
          <div className="onboarding-mobile-schedule-demo-content-title">Request a personalized demo</div>
          <div className="onboarding-mobile-schedule-demo-content-description mt-2">
            Learn to run engaging meetings, create accountability, and manage your team with PI Perform.
          </div>
        </div>

        <WpButtonGroup stacked>
          <WpButton variant="primary" size="lg" onClick={handleScheduleDemoButtonClick}>
            Schedule demo
          </WpButton>
          <WpButton variant="tertiary" onClick={() => advanceOnboardingState()}>
            Not now
          </WpButton>
        </WpButtonGroup>
      </div>
      <div className="onboarding-mobile-schedule-demo-content-socialproof">
        <SocialProof />
      </div>
    </div>
  );
}

export default ScheduleDemo;
